import { TimesheetColumnFilters } from 'entities/timesheet';

type TableFilters = Record<string, React.Key[] | null>;

export const mapFilterDTOToTableFilters = (filters: TimesheetColumnFilters): TableFilters => {
  const tableFilters: TableFilters = {};

  if (filters.timesheetStatus !== undefined) {
    if (filters.timesheetStatus === null) {
      // Both checkboxes selected
      tableFilters.status = ['true', 'false'];
    } else {
      tableFilters.status = [filters.timesheetStatus === 'APPROVED' ? 'true' : 'false'];
    }
  }

  if (filters.billable !== undefined) {
    if (filters.billable === null) {
      // Both checkboxes selected
      tableFilters.billable = ['true', 'false'];
    } else {
      tableFilters.billable = [filters.billable ? 'true' : 'false'];
    }
  }

  // Range filters (sliders)
  if (filters.minProjectedCostHours !== undefined || filters.maxProjectedCostHours !== undefined) {
    tableFilters.projectedCostHours = [
      String(filters.minProjectedCostHours ?? 0),
      String(filters.maxProjectedCostHours ?? 200),
    ];
  }

  if (filters.minActualCostHours !== undefined || filters.maxActualCostHours !== undefined) {
    tableFilters.actualCostHours = [String(filters.minActualCostHours ?? 0), String(filters.maxActualCostHours ?? 200)];
  }

  if (filters.minProjectedBillHours !== undefined || filters.maxProjectedBillHours !== undefined) {
    tableFilters.projectedBillHours = [
      String(filters.minProjectedBillHours ?? 0),
      String(filters.maxProjectedBillHours ?? 200),
    ];
  }

  if (filters.minActualBillHours !== undefined || filters.maxActualBillHours !== undefined) {
    tableFilters.actualBillHours = [String(filters.minActualBillHours ?? 0), String(filters.maxActualBillHours ?? 200)];
  }

  if (filters.minInvolvement !== undefined || filters.maxInvolvement !== undefined) {
    tableFilters.involvement = [String(filters.minInvolvement ?? 0), String(filters.maxInvolvement ?? 100)];
  }

  if (filters.minBilledInvolvement !== undefined || filters.maxBilledInvolvement !== undefined) {
    tableFilters.billedInvolvement = [
      String(filters.minBilledInvolvement ?? 0),
      String(filters.maxBilledInvolvement ?? 100),
    ];
  }

  return tableFilters;
};
